import { useState, useEffect } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { appFirebase } from "../../firebaseConfig/firebase";
import { Container, Row, Col } from "react-bootstrap";
import { Login } from "../Login/Login";

export const MaterialABMNew = () => {
  const auth = getAuth(appFirebase);
  const [usuario, setUsuario] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    console.log('Iniciando efecto de autenticación');
    let unsubscribe;
    
    try {
      unsubscribe = onAuthStateChanged(auth, (usuarioFirebase) => {
        console.log('Estado de autenticación cambiado:', usuarioFirebase ? 'usuario autenticado' : 'no autenticado');
        setUsuario(usuarioFirebase);
        setIsLoading(false);
      });
    } catch (error) {
      console.error('Error en la suscripción de autenticación:', error);
      setIsLoading(false);
    }

    return () => {
      console.log('Limpiando suscripción de autenticación');
      if (unsubscribe) {
        unsubscribe();
      }
    };
  }, [auth]);

  if (isLoading) {
    return (
      <Container>
        <Row className="justify-content-center mt-5">
          <Col md={6} className="text-center">
            <h3>Cargando...</h3>
          </Col>
        </Row>
      </Container>
    );
  }

  return (
    <Row>
      <Container fluid>
        {usuario ? (
          <Container>
            <Row>
              <Col md={4}>
                <Login />
              </Col>
            </Row>
            {/* Aquí irá el nuevo contenido */}
          </Container>
        ) : (
          <Container>
            <Login />
          </Container>
        )}
      </Container>
    </Row>
  );
}; 